"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _text = require("@mmc/text");
var _clsx4 = _interopRequireDefault(require("clsx"));
var _pfaHeroV = _interopRequireDefault(require("./pfa-hero-v2.css"));
var _pfaHero = _interopRequireDefault(require("./pfa-hero.props/pfa-hero.defaultProps"));
var _pfaHero2 = _interopRequireDefault(require("./pfa-hero.props/pfa-hero.propTypes"));
var _pfaHeroV2TextBlock = _interopRequireDefault(require("./pfa-hero-v2-text-block"));
var _Fragment; // We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var PFAHeroBackground = function PFAHeroBackground(_ref) {
  var _source, _source2, _clsx3;
  var data = _ref.data,
    theme = _ref.theme;
  var _ref2 = data || {},
    image = _ref2.backgroundImage.image,
    backgroundImageAltText = _ref2.backgroundImageAltText,
    background = _ref2.background,
    disclaimerBoxText = _ref2.disclaimerBoxText,
    disclaimerAlignment = _ref2.disclaimerAlignment,
    disclaimerBackground = _ref2.disclaimerBackground,
    addDarckOverlay = _ref2.addDarckOverlay,
    contentAlignment = _ref2.contentAlignment,
    isCarousel = _ref2.isCarousel,
    videoLink = _ref2.videoLink,
    mobileVideoLink = _ref2.mobileVideoLink,
    isEmbedVideo = _ref2.isEmbedVideo,
    autoPlayVideo = _ref2.autoPlayVideo,
    loopVideo = _ref2.loopVideo,
    enableRemoveControlVideo = _ref2.enableRemoveControlVideo,
    disclaimerData = _ref2.disclaimerData,
    mobileImage = _ref2.mobileImage.image,
    variation = _ref2.pfaVersion,
    imageSize = _ref2.imageSize;
  var _useState = (0, _react.useState)(''),
    imageURL = _useState[0],
    setImageURL = _useState[1];
  (0, _react.useEffect)(function () {
    if (window.innerWidth <= 500) {
      setImageURL(mobileImage);
    } else {
      setImageURL(image);
    }
  }, []);

  // useeffect when the window is resized
  (0, _react.useEffect)(function () {
    var handleResize = function handleResize() {
      if (window.innerWidth <= 500) {
        setImageURL(mobileImage);
      } else {
        setImageURL(image);
      }
    };
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [image, mobileImage, videoLink, mobileVideoLink]);
  var renderVideo = function renderVideo() {
    if (isEmbedVideo && isEmbedVideo !== undefined) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("iframe", {
        className: (0, _clsx4["default"])(_pfaHeroV["default"].videoBackground, _pfaHeroV["default"].videoBackgroundIframe, _pfaHeroV["default"].desktopOnly),
        src: videoLink,
        title: "YouTube video player",
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        allowFullScreen: true
      }), /*#__PURE__*/_react["default"].createElement("iframe", {
        className: (0, _clsx4["default"])(_pfaHeroV["default"].videoBackground, _pfaHeroV["default"].videoBackgroundIframe, _pfaHeroV["default"].mobileOnly),
        src: mobileVideoLink,
        title: "YouTube video player",
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        allowFullScreen: true
      }));
    }
    // video link code  = {window.innerWidth <= 767 ? false : true}
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("video", {
      className: (0, _clsx4["default"])(_pfaHeroV["default"].videoBackground, _pfaHeroV["default"].desktopOnly),
      autoPlay: autoPlayVideo,
      controls: enableRemoveControlVideo,
      loop: loopVideo,
      muted: true,
      playsInline: true
    }, _source || (_source = /*#__PURE__*/_react["default"].createElement("source", {
      src: videoLink,
      type: "video/mp4"
    })), "Your browser does not support the video tag."), /*#__PURE__*/_react["default"].createElement("video", {
      className: (0, _clsx4["default"])(_pfaHeroV["default"].videoBackground, _pfaHeroV["default"].mobileOnly),
      autoPlay: autoPlayVideo,
      controls: enableRemoveControlVideo,
      loop: loopVideo,
      muted: true,
      playsInline: true
    }, _source2 || (_source2 = /*#__PURE__*/_react["default"].createElement("source", {
      src: mobileVideoLink,
      type: "video/mp4"
    })), "Your browser does not support the video tag."));
  };
  var renderDisclaimer = function renderDisclaimer() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, disclaimerBoxText && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(_pfaHeroV["default"]['disclaimer-container'], _pfaHeroV["default"][disclaimerAlignment], background === 'dark' && _pfaHeroV["default"].darkTheme)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(_pfaHeroV["default"]['disclaimer-background'], _pfaHeroV["default"][disclaimerAlignment], background === 'dark' && _pfaHeroV["default"].darkTheme, disclaimerBackground === 'off' ? _pfaHeroV["default"]['no-background'] : '')
    }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
      className: (0, _clsx4["default"])(_pfaHeroV["default"]['pfa-hero-disclaimer']),
      text: disclaimerBoxText,
      tag: "p",
      disclaimerData: disclaimerData
    }))));
  };
  var renderBackground = function renderBackground() {
    var _clsx2;
    if (videoLink !== '' && videoLink !== undefined) {
      // add section image for background befor the video loads
      if (image !== '') {
        var _clsx;
        return /*#__PURE__*/_react["default"].createElement("section", {
          style: {
            backgroundImage: "url(" + imageURL + ")"
          },
          className: (0, _clsx4["default"])(_pfaHeroV["default"]['hero-wrapper-pfa'], _pfaHeroV["default"][variation], _pfaHeroV["default"][contentAlignment], _pfaHeroV["default"][imageSize], (_clsx = {}, _clsx[_pfaHeroV["default"].isCarousel] = isCarousel, _clsx)),
          title: backgroundImageAltText
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _clsx4["default"])(_pfaHeroV["default"]['video-wrapper'])
        }, renderVideo()));
      }

      // //only video no section image for background
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx4["default"])(_pfaHeroV["default"]['video-wrapper'])
      }, renderVideo());
    }
    return /*#__PURE__*/_react["default"].createElement("section", {
      style: {
        backgroundImage: "url(" + imageURL + ")"
      },
      className: (0, _clsx4["default"])(_pfaHeroV["default"]['hero-wrapper-pfa'], _pfaHeroV["default"][variation], _pfaHeroV["default"][contentAlignment], _pfaHeroV["default"][imageSize], (_clsx2 = {}, _clsx2[_pfaHeroV["default"].isCarousel] = isCarousel, _clsx2)),
      title: backgroundImageAltText
    });
  };
  if (variation === 'setRatio') {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(_pfaHeroV["default"]['set-ratio-wrapper'], background === 'dark' ? _pfaHeroV["default"].darkTheme : '')
    }, renderBackground(), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(_pfaHeroV["default"]['set-ratio-content-container'])
    }, /*#__PURE__*/_react["default"].createElement(_pfaHeroV2TextBlock["default"], {
      theme: theme,
      data: data,
      isCarousel: isCarousel,
      variation: variation
    })), renderDisclaimer()));
  }
  return /*#__PURE__*/_react["default"].createElement("section", {
    style: {
      backgroundImage: "url(" + imageURL + ")"
    },
    className: (0, _clsx4["default"])(_pfaHeroV["default"]['hero-wrapper-pfa'], _pfaHeroV["default"][variation], _pfaHeroV["default"][contentAlignment], _pfaHeroV["default"][imageSize], (_clsx3 = {}, _clsx3[_pfaHeroV["default"].isCarousel] = isCarousel, _clsx3), addDarckOverlay ? _pfaHeroV["default"]['dark-overlay'] : '', background === 'dark' && _pfaHeroV["default"].darkTheme),
    title: backgroundImageAltText
  }, videoLink !== '' && videoLink !== undefined ? renderVideo() : _Fragment || (_Fragment = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)), /*#__PURE__*/_react["default"].createElement(_pfaHeroV2TextBlock["default"], {
    theme: theme,
    data: data,
    isCarousel: isCarousel,
    variation: ""
  }), renderDisclaimer());
};
PFAHeroBackground.displayName = 'PFAHeroBackground';
PFAHeroBackground.defaultProps = {
  data: _pfaHero["default"]
};
var _default = exports["default"] = PFAHeroBackground;